import React from 'react';


export default function MyHorses() {
  return (
    <div className="max-w-6xl mx-auto p-4">
        <h1 className="text-3xl font-bold mb-6 text-center">My Horses</h1>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        </div>
    </div>
  );
}
